import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import Button from "@/components/common/Buttons/Button";
import useNavigationHelpers from "@/hooks/useNavigationHelpers";

export const Route = createFileRoute("/$locale/$partner/_app/_card/imei-instructions")({
	component: ImeiInstructions,
});

function ImeiInstructions() {
	const { t } = useTranslation();
	const { goToNextStep } = useNavigationHelpers();

	return (
		<div className="flex flex-col items-center justify-around h-full text-center relative overflow-y-auto">
			<h3 className="whitespace-pre-line pt-10 lg:pt-20">
				{t("instructions.Open the Dial app on your personal device and dial")}
			</h3>
			<div className="h-[50%] sm:h-[60%] flex flex-col justify-between px-6 w-full my-4">
				<div className="h-[30%] my-6 relative max-h-32">
					<img
						src={`/images/dial06.png`}
						alt="*#06#"
						className="w-full h-full object-contain"
					/>
				</div>
				<div className="h-[65%] w-full flex justify-center">
					<video
						className="h-full"
						src={"/videos/dial06.mp4"}
						autoPlay
						controls={false}
						muted
						playsInline
						loop
					/>
				</div>
			</div>
			<div className="mt-auto bg-fixed-buttons w-full">
				<Button
					label={t("btn.Continue")}
					onClick={() => goToNextStep()}
				/>
			</div>
		</div>
	);
}
